<ui-spin [uiDelay]="nzLoadingDelay" [uiSpinning]="nzLoading" [uiIndicator]="nzLoadingIndicator">
  <ng-container *ngIf="nzPaginationPosition === 'both' || nzPaginationPosition === 'top'">
    <ng-template [ngTemplateOutlet]="paginationTemplate"></ng-template>
  </ng-container>
  <div
    #tableMainElement
    class="ant-table"
    [class.ant-table-rtl]="dir === 'rtl'"
    [class.ant-table-fixed-header]="nzData.length && scrollY"
    [class.ant-table-fixed-column]="scrollX"
    [class.ant-table-has-fix-left]="hasFixLeft"
    [class.ant-table-has-fix-right]="hasFixRight"
    [class.ant-table-bordered]="nzBordered"
    [class.nz-table-out-bordered]="nzOuterBordered && !nzBordered"
    [class.ant-table-middle]="nzSize === 'middle'"
    [class.ant-table-small]="nzSize === 'small'">
    <ui-table-title-footer [title]="nzTitle" *ngIf="nzTitle"></ui-table-title-footer>
    <ui-table-inner-scroll
      *ngIf="scrollY || scrollX; else defaultTemplate"
      [data]="data"
      [scrollX]="scrollX"
      [scrollY]="scrollY"
      [contentTemplate]="contentTemplate"
      [listOfColWidth]="listOfAutoColWidth"
      [theadTemplate]="theadTemplate"
      [verticalScrollBarWidth]="verticalScrollBarWidth"
      [virtualTemplate]="nzVirtualScrollDirective ? nzVirtualScrollDirective.templateRef : null"
      [virtualItemSize]="nzVirtualItemSize"
      [virtualMaxBufferPx]="nzVirtualMaxBufferPx"
      [virtualMinBufferPx]="nzVirtualMinBufferPx"
      [tableMainElement]="tableMainElement"
      [virtualForTrackBy]="nzVirtualForTrackBy"></ui-table-inner-scroll>
    <ng-template #defaultTemplate>
      <ui-table-inner-default [tableLayout]="nzTableLayout" [listOfColWidth]="listOfManualColWidth" [theadTemplate]="theadTemplate" [contentTemplate]="contentTemplate"></ui-table-inner-default>
    </ng-template>
    <ui-table-title-footer [footer]="nzFooter" *ngIf="nzFooter"></ui-table-title-footer>
  </div>
  <ng-container *ngIf="nzPaginationPosition === 'both' || nzPaginationPosition === 'bottom'">
    <ng-template [ngTemplateOutlet]="paginationTemplate"></ng-template>
  </ng-container>
</ui-spin>
<ng-template #paginationTemplate>
  <ui-pagination
    *ngIf="nzShowPagination && data.length"
    [hidden]="!showPagination"
    class="ant-table-pagination ant-table-pagination-right"
    [uiShowSizeChanger]="nzShowSizeChanger"
    [uiPageSizeOptions]="nzPageSizeOptions"
    [uiItemRender]="nzItemRender!"
    [uiShowQuickJumper]="nzShowQuickJumper"
    [uiHideOnSinglePage]="nzHideOnSinglePage"
    [uiShowTotal]="nzShowTotal"
    [uiSize]="nzPaginationType === 'small' ? 'small' : nzSize === 'default' ? 'default' : 'small'"
    [uiPageSize]="nzPageSize"
    [uiTotal]="nzTotal"
    [uiSimple]="nzSimple"
    [uiPageIndex]="nzPageIndex"
    (uiPageSizeChange)="onPageSizeChange($event)"
    (uiPageIndexChange)="onPageIndexChange($event)"></ui-pagination>
</ng-template>
<ng-template #contentTemplate>
  <ng-content></ng-content>
</ng-template>
